import React from 'react';
import { Table, TableBody, TableHead, TableRow } from '@material-ui/core';
import TableCell from 'components/Table/TableCell';

import componentStyles from 'components/Table/Table.css';

export default props => {

  return (
    <Table style={componentStyles.table}>
      <TableHead style={componentStyles.thead}>
        <TableRow>
          {/* Create Table Head Row with col names */}
          {props.tableCols.map(n => {
            return typeof n !== 'string' || <TableCell key={n} cellContent={n} />;
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {props.data.map((n, index) => {
          return (
            <TableRow key={index}>
              {
                typeof n === 'string' 
                  ? <TableCell cellContent={n}/>
                  : Object.keys(n).map(key => key === '_id' || <TableCell cellContent={n[key]} />)
              }
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};



// WEBPACK FOOTER //
// ./src/views/ViewCustomerCase/Table/Table.jsx